export { default as AlbumController } from './AlbumController';

export const AddToAlbum = {
  _initialized: false,
  _container_id: 'album-selector-container',

  init: function() {
    if (this._initialized) {
      return;
    }

    this.container = undefined;

    $('body').delegate('[rel="album-add"]', 'click', this._onClick.bind(this));
    this._initialized = true;
  },

  _onClick: function(event) {
    event.preventDefault();
    var id = $(event.target).data('id');
    var source_page = $(event.target).data('source-page');

    if (source_page === undefined) {
      source_page = $(event.target)
        .parent()
        .data('source-page');
      if (source_page === undefined) {
        source_page = '';
      }
    }

    this.container = this._getContainer();
    this.container.load(
      '/do_ajax/user/albums?image=' + id + '&source_page=' + source_page,
      this._onAlbumSelectorLoaded.bind(this)
    );
  },

  _onAlbumSelectorLoaded: function() {
    angular.bootstrap(this.container);
  },

  _getContainer: function() {
    var container = $('#' + this._container_id);

    if (container.length > 0) {
      container.remove();
    }

    $('body').append(
      '<div id="' +
        this._container_id +
        '" ng-controller="AlbumController"></div>'
    );
    container = $('#' + this._container_id);

    return container;
  },
};
